import _classCallCheck from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/lukevoelk/WebstormProjects/OE-UI/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { CONTEXT_STORE } from '../globals';
export var createMinimalBaseAudioContextConstructor = function createMinimalBaseAudioContextConstructor(audioDestinationNodeConstructor, createAudioListener, eventTargetConstructor, isNativeOfflineAudioContext, unrenderedAudioWorkletNodeStore, wrapEventListener) {
  return /*#__PURE__*/function (_eventTargetConstruct) {
    _inherits(MinimalBaseAudioContext, _eventTargetConstruct);

    function MinimalBaseAudioContext(_nativeContext, numberOfChannels) {
      var _this;

      _classCallCheck(this, MinimalBaseAudioContext);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(MinimalBaseAudioContext).call(this, _nativeContext));
      _this._nativeContext = _nativeContext;
      CONTEXT_STORE.set(_assertThisInitialized(_assertThisInitialized(_this)), _nativeContext);

      if (isNativeOfflineAudioContext(_nativeContext)) {
        unrenderedAudioWorkletNodeStore.set(_nativeContext, new Set());
      }

      _this._destination = new audioDestinationNodeConstructor(_assertThisInitialized(_assertThisInitialized(_this)), numberOfChannels);
      _this._listener = createAudioListener(_assertThisInitialized(_assertThisInitialized(_this)), _nativeContext);
      _this._onstatechange = null;
      return _this;
    }

    _createClass(MinimalBaseAudioContext, [{
      key: "currentTime",
      get: function get() {
        return this._nativeContext.currentTime;
      }
    }, {
      key: "destination",
      get: function get() {
        return this._destination;
      }
    }, {
      key: "listener",
      get: function get() {
        return this._listener;
      }
    }, {
      key: "onstatechange",
      get: function get() {
        return this._onstatechange;
      },
      set: function set(value) {
        var wrappedListener = typeof value === 'function' ? wrapEventListener(this, value) : null;
        this._nativeContext.onstatechange = wrappedListener;
        var nativeOnStateChange = this._nativeContext.onstatechange;
        this._onstatechange = nativeOnStateChange !== null && nativeOnStateChange === wrappedListener ? value : nativeOnStateChange;
      }
    }, {
      key: "sampleRate",
      get: function get() {
        return this._nativeContext.sampleRate;
      }
    }, {
      key: "state",
      get: function get() {
        return this._nativeContext.state;
      }
    }]);

    return MinimalBaseAudioContext;
  }(eventTargetConstructor);
};